module.exports = __webpack_public_path__ + "static/media/ft2-fire.9ec29997.png";